module.exports = __webpack_public_path__ + "static/media/h4.ff2525e6.svg";